import { useContextStore } from '@wholebodyapp/stores';
import { minimatch } from 'minimatch';

/**
 *  Matches (returns true) if the supplied grants
 *  match (with wildcards) any of the required
 *  permissions
 *  @param  [{string}]   grants               list of permissions the user holds
 *  @param  [{string}]   routePermissions     permissions required to access the route
 *  @return Boolean
 */
function matchPermission (grants=[], routePermissions=[]) {
  return routePermissions.some(eaPermission =>
    grants.some(eaGrant => minimatch(eaGrant, eaPermission))
  );
}


export async function beforeEachHandler (to, from) {

  // should be rare, but it can happen!
  if (to?.meta?.noAuth)
    return true;

  const context = useContextStore();
  const user = context.getUser;

  // beware, the store initialzizes to an empty object (for easier refs!)
  // so check the user.email, not for the existence of user. Works for now
  // since all users *must* have an email.
  if (!user.email && to.name !== 'home') {
    return { name: 'home', query: {redir: to.fullPath }};
  }

  // if the endpoint has no permission restrictions, navigate!
  if (!to?.meta?.permissions)
    return true;

  // route has restricions, and user holds a matching grant
  const userGrants = context.getGrants.grants;
  if (matchPermission(userGrants, to.meta.permissions))
    return true;

  // we fallthrough to no permission...
  return { name: 'notAuthorized' };

}

